





































/** @format */

import { Vue, Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import TableWidthMixin from '@/common/mixins/table-width';
import AddEditArea from './add-edit-area.vue';
import { tableColums } from '../table-colums';
import { dictAlonePayMap } from '@/types/parking-lot-management/dictionaries';
import { deleteArea } from '@/api/parking-lot-management/index';

@Component({
  components: { AddEditArea }
})
export default class AddEditAreaList extends Mixins(TableWidthMixin) {
  // 当前车场id, 车场创建时使用
  @Prop()
  parkId!: string;

  @Prop({ type: Boolean, default: false })
  isParkDisabled!: boolean;
  // @Prop()
  // tableDatas!: any[]

  // 表数据
  tableData: any[] = [];

  // 表单的显示和隐藏
  isShowForm: boolean = true;
  isEdit: boolean = false;
  dataForm = null;
  areaId = '';

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 50,
        customRender: (text: any, record: any, index: number) => `${index + 1}`
      },
      {
        title: '区域名称',
        dataIndex: 'areaName',
        width: 200
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 200
      },
      {
        title: '区域车位数',
        dataIndex: 'plateNum',
        width: 160
      },
      {
        title: '固定车位数',
        dataIndex: 'propertyNums'
        // width: 120,
      },
      // {
      //   title: '出租车位数',
      //   dataIndex: 'monthNum',
      //   width: 120,
      // },
      {
        title: '临停车位数',
        dataIndex: 'tempNum'
        // width: 120,
      },
      // {
      //   title: '区域剩余车位',
      //   dataIndex: 'areaSurNum',
      //   width: 120,
      // },
      // {
      //   title: '是否独立计费',
      //   dataIndex: 'alonePay',
      //   width: 110,
      //   customRender: (text: any) => dictAlonePayMap[text],
      // },
      // {
      //   title: '满位是否允许进入',
      //   dataIndex: 'isZeroAllowedEnter',
      //   width: 110,
      // },
      // {
      //   title: '非授权车辆是否禁入',
      //   dataIndex: 'unauthorizedEnter',
      //   width: 160,
      // },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 160,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  // method
  // 删除项
  async toDelete(row: any) {
    const { areaId, parkId } = row;
    console.log(row);
    try {
      const { status, data, msg, code } = await deleteArea({
        areaId,
        parkId
      });
      console.log(status, data, msg, code);
      if (status === '9999') {
        this.$message.success('删除成功');
        const index = this.tableData.findIndex(item => item.areaId === areaId);
        if (index > -1) {
          this.tableData.splice(index, 1);
        }
        // this.tableData = this.tableData.filter((item: any) => item.areaId !== this.areaId)
        // this.areaId = ''
      } else {
        this.$message.error('删除失败');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '删除失败');
    }
  }

  // 隐藏表单
  hideForm() {
    this.isShowForm = false;
  }

  // 表单保存成功
  onFormOk(data: any) {
    console.log(data);
    this.isShowForm = false;
    if (this.isEdit) {
      // 编辑成功更新
      const index = this.tableData.findIndex(item => item.areaId === data.areaId);
      if (index > -1) {
        this.tableData.splice(index, 1, data);
      }
    } else {
      // 新增成功更新
      this.tableData.push(data);
      console.log(data);
      // this.areaId = data.areaId
      this.$emit('areaSubmit', data);
    }
  }

  // 展示新增表单
  showAddForm() {
    this.isShowForm = true;
    this.isEdit = false;
    this.dataForm = null;
  }

  // 展示编辑表单
  showEditForm(data: any) {
    console.log(data);
    this.isShowForm = true;
    this.isEdit = true;
    this.dataForm = data;
  }
}
